import { useQuery } from 'react-query';
import { DocDataByMark } from './useDeliveryStatusByMark';
import { apiRQ } from '../../api';

export const isAadeQrUrl = (url: string | undefined): boolean => !!url && url.includes('aade.gr');

const getDeliveryStatusByQrUrlService = async (qrUrl: string): Promise<DocDataByMark> => {
  const resp = await apiRQ.get<DocDataByMark>('/delivery/qr-status/', { params: { qrUrl } });

  return resp?.data;
};

export const useDeliveryStatusByQrUrl = (qrUrl: string | undefined) => {
  return useQuery<DocDataByMark, Error>(
    ['useDeliveryStatusByQrUrl', qrUrl],
    () => getDeliveryStatusByQrUrlService(qrUrl!),
    {
      enabled: isAadeQrUrl(qrUrl),
      cacheTime: 2000,
      staleTime: 2000,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    },
  );
};
